import Vue from 'vue'
import axios from 'axios'
Vue.prototype.fileUrl = process.env.VUE_APP_FILE_URL
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
import Cookies from 'js-cookie'
// 请求拦截
axios.interceptors.request.use(
  (requestConfig) => {
    if (requestConfig.setToken == undefined) {
      let loginInfo = Cookies.get('loginInfo')
      let token = loginInfo ? JSON.parse(loginInfo).token : ''
      if (token) {
        requestConfig.headers.Authorization = token
      }
    }
    return requestConfig
  },
  (error) => {
    Promise.reject(error)
  }
)

// 响应拦截
axios.interceptors.response.use((res) => {
  switch (res.data.errorCode) {
    case 165:
      // token信息错误，跳转到登录页面
      Cookies.set('loginInfo', '')
      window.location.reload()
      break
    case 202:
      // 无token信息，跳转到登录页面
      Cookies.set('loginInfo', '')
      window.location.reload()
      break
  }

  return res
})

export default axios
